// Объявляем глобальный тип для window
declare global {
  interface Window {
    __APP_CONFIG__?: {
      VITE_API_BASE_URL?: string;
      VITE_WS_URL?: string;
    };
  }
}

export class USER {
    static BASE = "api/v1/client"
    static VALIDATE = `${USER.BASE}/validate`
    static PROFILE = `${USER.BASE}/user/profile`
    static BALANCE = `${USER.BASE}/user/balance`
    static SUBSCRIPTION = `${USER.BASE}/user/subscription`
    static TRANSACTION = `${USER.BASE}/transactions`
    static SETTINGS = `${USER.BASE}/settings`
    static UPDATE_LANGUAGE =`${USER.BASE}/settings/language`
    static UPDATE_MODEL = `${USER.BASE}/settings/model`
}

export class REFERRAL {
    static BASE = "/referral"
    static SUMMARY = `${REFERRAL.BASE}/summary`
    static REFERRED_USERS = `${REFERRAL.BASE}/referred-users`
}

export class BASIC_CONSTANTS_NETWORK {
    static BASE_URL = 
   import.meta.env.DEV
    ? "/api/v1"
    : (window.__APP_CONFIG__?.VITE_API_BASE_URL ||
       import.meta.env.VITE_API_BASE_URL || 
       "/api/v1/client");
    
    static WS_URL = 
        window.__APP_CONFIG__?.VITE_WS_URL ||
        import.meta.env.VITE_WS_URL ||
        "wss://gpt-bot.kabco.tech/ws";
    
    static USER = USER
    static REFERRAL = REFERRAL
}
